import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.getSelfBuildList, {
        search,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
